import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { SignupResultLayout } from '../SignupResultLayout/SignupResultLayout';
import { signupCheckEmailStyles } from './SignupCheckEmail.styles';

export function SignupCheckEmail() {
  const theme = useTheme();

  return (
    <SignupResultLayout title="Check your email">
      <Typography sx={signupCheckEmailStyles.resultMessage(theme)}>
        We sent you a link to finish creating your Exploros account.
      </Typography>
      <Box sx={signupCheckEmailStyles.resultActions()} />
    </SignupResultLayout>
  );
}
